import React from 'react'
import { Card } from 'antd'
import PageHeader from 'ant-design-pro/lib/PageHeader'

const Header = (props) => (
  <Card style={{ marginBottom: 20 }}>
    <PageHeader
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: 20 }}>
            {props.title}
          </span>
          <div>
            {props.children}
          </div>
        </div>
      }
      breadcrumbList={props.breadcrumbList}
    />
  </Card>
)

export default Header



// WEBPACK FOOTER //
// ./src/containers/Header/index.js